import Vue, { computed, reactive } from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/index.vue'

import type { RouteConfig } from 'vue-router'
// import JtUiDemo from './jt-ui-demo'

Vue.use(Router)

/*
  redirect:                      if set to 'noredirect', no redirect action will be trigger when clicking the breadcrumb
  meta: {
    title: 'title'               the name showed in subMenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon showed in the sidebar
    breadcrumb: false            if false, the item will be hidden in breadcrumb (default is true)
    ,
    meta: {
      hidden: true
    }: true                 if true, this route will not show in the sidebar (default is false)
  }
*/
export const constantRoutes: RouteConfig[] = [
  // 新页面路由可以先写在这里
  // ---------
  // ...JtUiDemo,
  {
    path: '/ocr',
    name: 'OCRLayout',
    component: Layout,
    children: [
      {
        path: '/ocr',
        name: 'OCRIndex',
        component: () => import('@/views/OCR/index.vue'),
        meta: {
          title: '图片识别',
          roles: ['admin', 'user'],
          icon: 'nav_text_train',
          keepAlive:false,
          navSortIndex: 1
        },
      },
    ],
    meta: {
      title:'图片识别',
      navSortIndex: 1
    }
  },
  {
    path: '/mt',
    name: 'MTLayout',
    component: Layout,
    children: [
      {
        path: '/mt',
        name: 'MTIndex',
        component: () => import('@/views/MT/index.vue'),
        meta: {
          title: '文本翻译',
          roles: ['admin', 'user'],
          icon: 'nav_hot_word',
          navSortIndex: 1
        }
      }
    ],
    meta: {
      title:'文本翻译',
      navSortIndex: 1
    }
  },
  {
    path: '/asr',
    name: 'ASRLayout',
    component: Layout,
    children: [
      {
        path: '/asr',
        name: 'ASRIndex',
        component: () => import('@/views/ASR/index.vue'),
        meta: {
          title: '语音识别',
          roles: ['admin', 'user'],
          icon: 'nav_real_time',
          navSortIndex: 1,
        },
      },
    ],
    meta: {
      title:'语音识别',
      navSortIndex: 1
    }
  },
  {
    path: '/tts',
    name: 'TTSLayout',
    component: Layout,
    children: [
      {
        path: '/tts',
        name: 'TTSIndex',
        component: () => import('@/views/TTS/TtsIndex.vue'),
        meta: {
          title: '语音合成',
          roles: ['admin', 'user'],
          icon: 'nav_offline_transmit',
          keepAlive: true,
          navSortIndex: 1,
        }
      }
    ],
    meta: {
      title:'语音合成',
      navSortIndex: 1
    }
  },
  {
    path: '/doc',
    name: 'NLPLayout',
    component: Layout,
    children: [
      {
        path: '/doc',
        name: 'NLPIndex',
        component: () => import('@/views/NLP/NlpIndex.vue'),
        meta: {
          title: '文本解读',
          roles: ['admin', 'user'],
          icon: 'nav_record_manage',
          navSortIndex: 1,
        },
      },
    ],
    meta: {
      title:'文本解读',
      navSortIndex: 1
    }
  },
  {
    path: '/meeting',
    name: 'MeetingLayout',
    component: Layout,
    children: [
      {
        path: '/meeting',
        name: 'MeetingIndex',
        component: () => import('@/views/Meeting/index.vue'),
        meta: {
          title: '智能会议',
          roles: ['admin', 'user'],
          icon: 'nav_record_manage',
          navSortIndex: 1,
        },
      },
    ],
    meta: {
      title:'智能会议',
      navSortIndex: 1
    }
  },
  {
    path: '/sg',
    name: 'SGLayout',
    component: Layout,
    meta: {
      title:'字幕生成',
      navSortIndex: 1
    },
    children: [
      {
        path: '/sg',
        name: 'SGIndex',
        component: () => import('@/views/SubtitlesGeneration/index.vue'),
        meta: {
          title: '字幕生成',
          roles: ['admin', 'user'],
          icon: 'nav_record_manage',
          navSortIndex: 1,
        },
      },
    ]
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: () => import('@/views/login/index.vue'),
  //   meta: {
  //     hidden: true,
  //     title: '登录',
  //     inWhiteList: true,
  //   }
  // },
  // {
  //   path: '/account',
  //   name: 'accountLayout',
  //   component: Layout,
  //   meta: {
  //     title:'账户信息',
  //     navSortIndex: 2
  //   },
  //   children: [
  //     {
  //       path: '/account',
  //       name: 'accountIndex',
  //       component: () => import('@/views/Account/index.vue'),
  //       meta: {
  //         title: '使用统计',
  //         roles: ['admin', 'user'],
  //         icon: 'nav_real_time',
  //         navSortIndex: 2,
  //       },
  //     },
  //   ]
  // },
  {
    path: '/',
    component: () => import('@/views/HomePage/index.vue'),
    meta: {
      hidden: true
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: {
      hidden: true,
      title: '404',
      inWhiteList: true,
    },
  }
]

export const dynamicRoutes = []

export const createRouter = (routes: RouteConfig[]) =>
  new Router({
    mode: 'history',  // Enable this if you need.
    scrollBehavior: (to, from, savedPosition) => {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    },
    base: process.env.VUE_APP_ROUTER_BASE_URL,
    routes: [...routes] // 浅拷贝防止其他地方引用 router.options.routes 时都在操作同一个对象
  })

const router = createRouter([
  ...constantRoutes,
  ...dynamicRoutes,
  {
    path: '*',
    redirect: '/404',
    meta: { hidden: true }
  }
]) // 默认全部加载, 如果开启路由鉴权, 会被重置, 便于插拔鉴权功能

export function useRouter() {
  return router
}

export function useRoute() {
  reactive(router)
  const route = computed(() => router.currentRoute)
  return route
}

export default router

export {
  LocationQuery,
  LocationQueryValue
} from './type'
